export const runStatusColors: Record<string, string> = {
  success: 'success',
  partial: 'warning',
  failed: 'error',
  running: 'processing',
};

export const runStatusLabels: Record<string, string> = {
  success: '成功',
  partial: '部分成功',
  failed: '失败',
  running: '执行中',
};

export const triggerLabels: Record<string, string> = {
  manual: '手动',
  schedule: '定时',
};

export const notificationStatusColors: Record<string, string> = {
  success: 'success',
  failed: 'error',
};

export const notificationStatusLabels: Record<string, string> = {
  success: '已通知',
  failed: '通知失败',
};
